








































































import { Vue, Component } from "vue-property-decorator";
import { AnniversaryListing } from "@/api";
import loading from "@/components/loader/loading.vue";
import { descendingList as groupAnniversaryList } from "@/common/date_group_order";

@Component({
  components: {
    loading,
  },
})
export default class ReviewAnnualList extends Vue {
  isDataLoading = false;

  selectEmployee(id: number) {
    this.$router.push(`/company-directory/profile/${id}`);
  }

  get anniversaries() {
    const list = this.$store.getters[
      "dashboard/reviewListAnnual"
    ] as AnniversaryListing;
    const anniversaries = groupAnniversaryList(list, true);
    return anniversaries;
  }
}
